import { defineStore } from 'pinia';
import EmployeeService from '@/api/services/employee.service';
import { useUiStore } from './uiStore';
import { employeeId } from '@/views/team-holidays/teamHierarchy';

// Requests stay outside Pinia state; the store is deliberately not persisted.
const requests = new WeakMap();
const hasTeam = employee => Array.isArray(employee?.teamMembers) &&
  employee.teamMembers.some(member => employeeId(member) && employeeId(member) !== employeeId(employee));

export const useTeamHolidaysStore = defineStore('myTeam', {
  state: () => ({ employee: null, employeeId: null }),
  getters: {
    isTeamLeader: state => hasTeam(state.employee),
    canAccessFor: state => user => employeeId(user) === state.employeeId &&
      !!state.employeeId && !user?.roles?.includes('ROLE_EXTERNAL_COLLABORATOR') &&
      hasTeam(state.employee),
  },
  actions: {
    async loadEmployee(id, force = false) {
      const key = id == null ? null : String(id);
      if (this.employeeId !== key) {
        requests.get(this)?.controller.abort();
        requests.delete(this);
        this.employee = null;
        this.employeeId = key;
      }
      if (!key) return null;
      if (this.employee && !force) return this.employee;
      const pending = requests.get(this);
      if (pending?.key === key) return pending.promise;
      // Keep the verified membership visible while refreshing the same user.
      // The route still awaits the fresh result before granting navigation.
      const uiStore = useUiStore();
      uiStore.startLoading();
      const controller = new AbortController();
      const promise = EmployeeService.getEmployee(id, { signal: controller.signal, silent: true }).then(response => {
        if (!response?.data || employeeId(response.data) !== key) throw new Error('No se pudo comprobar el equipo');
        if (this.employeeId === key && requests.get(this)?.promise === promise) this.employee = response.data;
        return response.data;
      }).catch(error => {
        if (this.employeeId === key && requests.get(this)?.promise === promise) this.employee = null;
        throw error;
      }).finally(() => {
        if (requests.get(this)?.promise === promise) requests.delete(this);
        uiStore.stopLoading();
      });
      requests.set(this, { key, promise, controller });
      return promise;
    },
  },
});
